import axios from "axios";
import errorHandler from "../utils/errorHandler";
import {INVESTMENT} from "../stores/app";
import {INVESTMENT_URL, INVESTMENT_CATEGORY_URL, FUND_INVESTMENT, INVESTMENT_DETAIL_URL} from "./index";

export const getInvestment = () => {
    return function(dispatch) {
        return axios.get(INVESTMENT_URL).then(async(response) => {
            await dispatch(INVESTMENT({investment: response.data.investment}));

            return {
                error: false
            }
        }).catch((error) => {
            return errorHandler(error);
        });
    }
}

export const getInvestmentDetail = (id) => {
    return axios.get(INVESTMENT_DETAIL_URL(id)).then(async(response) => {
        return {
            data: response.data,
            error: false
        }
    }).catch((error) => {
        return errorHandler(error);
    });
}

export const investmentByCategory = (name) => {
    return function(dispatch) {
        return axios.get(INVESTMENT_CATEGORY_URL(name)).then(async(response) => {
            await dispatch(INVESTMENT({investment: response.data.investment}));

            return {
                error: false
            }
        }).catch((error) => {
            return errorHandler(error);
        });
    }
}

export const fundInvestment = (data) => {
    return axios.post(FUND_INVESTMENT, data).then(async(response) => {
        return {
            error: false
        }
    }).catch((error) => {
        return errorHandler(error);
    });
}
